import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps } from 'react-router-dom';

import { IApplicationState, IConnectedReduxProps } from '../Store';
import { I18N } from '../Store/I18n/Types';
import { ILayoutState } from '../Store/Layout/Types';

import { AppBar } from './AppBar';
import { Drawer } from './Sidebar/Drawer';


interface IPropsFromState {
    i18n: I18N;
    layout: ILayoutState;
}

type AllProps =
    MD.WithTheme &
    MD.WithStyles<typeof styles> &
    IPropsFromState &
    RouteComponentProps<{}> &
    IConnectedReduxProps;

const styles = (theme:any) => MD.createStyles({
    container: {
        height: '100%',
    },
    content: {
        '&.noDrawer': {
            paddingLeft: theme.spacing(3),
        },
        flexGrow: 1,
        minHeight: `calc(100% - ${theme.CatalogManager.dimensions.appBarHeight})`,
        overflow: 'hidden',
        padding: theme.spacing(3),
        paddingLeft: theme.CatalogManager.dimensions.drawerWidth + theme.spacing(3),
        paddingTop: theme.CatalogManager.dimensions.appBarHeight + theme.spacing(3),
        transition: 'padding-left 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
    },
    toolbar: theme.mixins.toolbar,
    listGridContainer: {
      margin: '15px'
    },
    listItemContainer: {
      border: '1px solid #cccccc',
      padding: '5px',
      borderRadius: '5px',
    }
});

export class LayoutComponent extends React.Component<AllProps> {

    public render(): React.ReactNode {
        const { classes } = this.props;
        return (
            <MD.Grid className={classes.container} id='fffff' container>
                <Route component={AppBar} />
                <Route component={Drawer} />
                <MD.Grid
                    item
                    className={classes.content + (
                        (this.props.layout.showDrawer) ?
                        '' :
                        ' noDrawer'
                    )}
                    xs={12}
                >
                    {this.props.layout.pageContent}
                </MD.Grid>
            </MD.Grid>
        );
    }
}

const mapStateToProps = ({ i18n, layout }: IApplicationState) => ({
    i18n: i18n.i18n,
    layout,
});

export const Layout =
    connect(mapStateToProps)(MD.withTheme(MD.withStyles(styles)(LayoutComponent)));
